import { GxIcon } from '@garpix/garpix-web-components-react';
import React, {FC } from 'react';
import useClipboard from 'react-use-clipboard';
import { CopyIcon } from '../../assets';
import Button from '../Button';
import styles from './styles/index.module.scss';

interface IClipboard {
    value: string,
}

const Clipboard: FC<IClipboard> =  ({ value }) => {
    const [, setCopied] = useClipboard(value);

    return (
        <div className={styles['clipboard']}>
            <div className={styles['clipboard--text']}>{value}</div>
            <Button className={styles['clipboard--btn']} theme='btn--transparent_link' onClick={setCopied} type='button'>
                <GxIcon src={CopyIcon} />
            </Button>
        </div>
    )
};

export default Clipboard;


